module.exports = __webpack_public_path__ + "media/images/enum-mark-44bb381e48d3a51bbf09ed051ac2f685.png";